import { ReactElement } from "react";
import { DraggableProvidedDragHandleProps } from "@hello-pangea/dnd";
import styled from "styled-components";
import { theme } from "../../theme";
import { h } from "../../h";
import { ItemHidableStyled } from "../Main/ItemHidableStyled";

type DragHandleProps = {
    dragHandleProps: DraggableProvidedDragHandleProps | undefined;
};

const DragHandleContainerStyled = styled(ItemHidableStyled)`
    width: 40px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const DragHandle = ({
    dragHandleProps,
}: DragHandleProps): ReactElement => {
    return h(
        DragHandleContainerStyled,
        dragHandleProps,
        h(
            `svg`,
            {
                width: 10,
                height: 30,
                viewBox: `0 0 10 30`,
            },
            h(`path`, {
                d: `M0 0H3.33333V3.33333H0V0ZM6.66667 0H10V3.33333H6.66667V0ZM0 6.66667H3.33333V10H0V6.66667ZM6.66667 6.66667H10V10H6.66667V6.66667ZM0 13.3333H3.33333V16.6667H0V13.3333ZM6.66667 13.3333H10V16.6667H6.66667V13.3333ZM0 20H3.33333V23.3333H0V20ZM6.66667 20H10V23.3333H6.66667V20ZM0 26.6667H3.33333V30H0V26.6667ZM6.66667 26.6667H10V30H6.66667V26.6667Z`,
                fill: theme.colorMain,
            }),
        ),
    );
};
